import { AppModel } from '../../constants/api';
import { useApp, useStore } from '../../store/appStores';

export const useCurrentWorkingDay = () => {
  const workingDays = useStore(AppModel.WORKING_DAY);
  const selectedWorkingDay = useApp((s) => s.selectedWorkingDay);

  return workingDays.find((x) => x._id === selectedWorkingDay) ?? null;
};
